// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".heart[data-v-c7fb138c]{width:.875rem}.heart-button:hover .heart[data-v-c7fb138c]{transform:scale(1.2)}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.ie-like[data-v-c7fb138c]{height:14px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
